export interface CityProgress {
  city: string;
  percentage: number;
}

export interface ProvinceProgress {
  province: string;
  percentage: number;
  cities: CityProgress[];
  totalAffected: number;
}

export const programRegionProgressData: Record<string, ProvinceProgress[]> = {
  "akses-layanan": [
    {
      province: "Jawa Barat",
      percentage: 85,
      cities: [
        { city: "Bogor", percentage: 401.86 },
        { city: "Garut", percentage: 252.56 },
        { city: "Bandung", percentage: 236.06 },
        { city: "Cianjur", percentage: 232.61 },
        { city: "Cirebon", percentage: 229.64 },
        { city: "Indramayu", percentage: 196.78 },
        { city: "Bekasi", percentage: 191 },
        { city: "Tasikmalaya", percentage: 165.99 },
      ],
      totalAffected: 1906.5,
    },
    {
      province: "Jawa Timur",
      percentage: 85,
      cities: [
        { city: "Malang", percentage: 235.63 },
        { city: "Jember", percentage: 216.76 },
        { city: "Sampang", percentage: 213.98 },
        { city: "Probolinggo", percentage: 196.26 },
        { city: "Sumenep", percentage: 188.48 },
        { city: "Bangkalan", percentage: 187.9 },
        { city: "Tuban", percentage: 168.86 },
        { city: "Kediri", percentage: 57.47 },
      ],
      totalAffected: 1465.34,
    },
    {
      province: "Jawa Tengah",
      percentage: 85,
      cities: [
        { city: "Brebes", percentage: 257.9 },
        { city: "Banyumas", percentage: 194.87 },
        { city: "Pemalang", percentage: 173.38 },
        { city: "Cilacap", percentage: 164.22 },
        { city: "Kebumen", percentage: 162.54 },
        { city: "Grobogan", percentage: 148.1 },
        { city: "Magelang", percentage: 132.21 },
        { city: "Demak", percentage: 131.47 },
      ],
      totalAffected: 1364.69,
    },
    {
      province: "Banten",
      percentage: 85,
      cities: [
        { city: "Tangerang", percentage: 265.9 },
        { city: "Kota Tangerang", percentage: 124.76 },
        { city: "Lebak", percentage: 106.52 },
        { city: "Pandeglang", percentage: 105.35 },
        { city: "Serang", percentage: 68.51 },
        { city: "Kota Tangerang Selatan", percentage: 44.61 },
        { city: "Kota Serang", percentage: 41.07 },
        { city: "Kota Cilegon", percentage: 16.05 },
      ],
      totalAffected: 772.77,
    },
    {
      province: "Sumatera Selatan",
      percentage: 78,
      cities: [
        { city: "Kota Palembang", percentage: 162.3 },
        { city: "Ogan Komering Ilir", percentage: 105.26 },
        { city: "Banyuasin", percentage: 77.63 },
        { city: "Musi Banyuasin", percentage: 69.81 },
        { city: "Muara Enim", percentage: 64.82 },
        { city: "Oku Timur", percentage: 62.89 },
        { city: "Lahat", percentage: 58.66 },
        { city: "Musi Rawas", percentage: 54.7 },
      ],
      totalAffected: 656.07,
    },
    {
      province: "Lampung",
      percentage: 78,
      cities: [
        { city: "Lampung Timur", percentage: 132.17 },
        { city: "Lampung Tengah", percentage: 127.83 },
        { city: "Lampung Selatan", percentage: 127.74 },
        { city: "Lampung Utara", percentage: 98.99 },
        { city: "Bandar Lampung", percentage: 80.19 },
        { city: "Tanggamus", percentage: 63.56 },
        { city: "Pasawaran", percentage: 51.09 },
        { city: "Way Kanan", percentage: 44.17 },
      ],
      totalAffected: 625.74,
    },
    {
      province: "NTT",
      percentage: 69,
      cities: [
        { city: "Timor Tengah Selatan", percentage: 116.74 },
        { city: "Sumba Barat Daya", percentage: 97.68 },
        { city: "Kupang", percentage: 87.5 },
        { city: "Manggarai Timur", percentage: 70.99 },
        { city: "Sumba Timur", percentage: 70.35 },
        { city: "Manggarai", percentage: 65.81 },
        { city: "Ende", percentage: 58.92 },
        { city: "Timor Tengah Selatan", percentage: 53.44 },
      ],
      totalAffected: 621.43,
    },
    {
      province: "Sumatera Utara",
      percentage: 78,
      cities: [
        { city: "Kota Medan", percentage: 171.6 },
        { city: "Langkat", percentage: 90.28 },
        { city: "Deli Serdang", percentage: 77.7 },
        { city: "Simalungun", percentage: 61.12 },
        { city: "Assahan", percentage: 54.57 },
        { city: "Nias Selatan", percentage: 54.29 },
        { city: "Tapanuli Tengah", percentage: 46.79 },
        { city: "Batu Bara", percentage: 44.28 },
      ],
      totalAffected: 600.63,
    },
    {
      province: "Aceh",
      percentage: 78,
      cities: [
        { city: "Aceh Singkil", percentage: 132.2 },
        { city: "Aceh Barat", percentage: 122.1 },
        { city: "Pidie", percentage: 112.21 },
        { city: "Aceh Utara", percentage: 98.3 },
        { city: "Pidie Jaya", percentage: 77.7 },
      ],
      totalAffected: 542.51,
    },
    {
      province: "Sumatera Barat",
      percentage: 78,
      cities: [
        { city: "Kepulauan Mentawai", percentage: 162.9 },
        { city: "Pasaman Barat", percentage: 151.1 },
        { city: "Pesisir Selatan", percentage: 142.2 },
        { city: "Agam", percentage: 125.4 },
      ],
      totalAffected: 581.6,
    },
    {
      province: "NTB",
      percentage: 69,
      cities: [
        { city: "Lombok Timur", percentage: 110.28 },
        { city: "Lombok Utara", percentage: 63.89 },
        { city: "Sumbawa Timur", percentage: 32.76 },
      ],
      totalAffected: 206.93,
    },
  ],
};
